<template>
  <div>
    <ul class="pl-0 border-0 border-b-2 border-solid border-border mt-0" data-test="tab-menu">
      <li v-for="(tab, key) in tabList" :key="tab.title" @click="selectTab(key)" class="cursor-pointer inline-block px-lg py-base" :class="{'tab-active': selectedTab === key}">
        {{ tab }}
      </li>
    </ul>
    <template v-for="(tab, key) in tabList">
      <div :key="key" v-show="key === selectedTab" :data-test="key">
        <slot :name="key" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Tabs',

  props: {
    tabList: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedTab: Object.keys(this.tabList)[0],
    };
  },
  methods: {
    selectTab(key) {
      this.selectedTab = key;
      this.$emit('tab-selected', key);
    },
  },
};
</script>

<style scoped>
  .tab-active {
    @apply
    border-0
    border-b-4
    border-solid
    border-signablePrimary1
  }
</style>
